import { Content } from "@/ui/Content";
import { specialisms_helper } from "@/helpers/specialisms_helper";
import {
  SpecialismPageBannerSection,
  SpecialismPageContentSection,
  SpecialismPageGridSection,
} from "@/components/SpecialismPage";

const additionalComponents = {
  SpecialismPageBannerSection,
  SpecialismPageContentSection,
  SpecialismPageGridSection,
};

import { getSpecialismsPageChildStaticProps } from "@/functions/getSpecialismsPageChildStaticProps";
import { getSpecialismsParentPageStaticProps } from "@/functions/getSpecialismsParentPageStaticProps";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  if (url_slug === "public-sector") {
    return getSpecialismsParentPageStaticProps(url_slug);
  }

  if (specialisms_helper.find(url_slug).parent.id !== null) {
    return getSpecialismsPageChildStaticProps(url_slug);
  }

  return getSpecialismsParentPageStaticProps(url_slug);
}

export async function getStaticPaths() {
  const includes = specialisms_helper.fetch({
    filter: (i) => "page" in i && i["page"] === true, // only items with page enabled
  });

  return {
    paths: specialisms_helper.toPaths({
      includes: includes.map((i) => i.id),
    }),
    fallback: false,
  };
}
